import React from "react";
import { DeleteItem, SuccessfulDelete, SuccessModal } from "../../modal";
import EditClassroom from "./EditClassroom";

const ClassActivityBtn = ({
  setEditModal,
  handleDeleteSubject,
  openDeleteModal,
  cancelModal,
  confirmDelete,
  openSuccessfulDeleteModal,
  closeSuccessfulDeleteModal,
  editModal,
  classroom,
  setClassroom,
  description,
  setDescription,
  members,
  setMembers,
  handleUpdate,
  successModal,
  closeSuccessModal,
}) => {
  return (
    <>
      <div className="flex gap-3">
        <button
          onClick={() => setEditModal(true)}
          className="py-3 px-4 bg-[#5002D0] text-white rounded-lg mr-2 font-semibold font-satoshi"
        >
          Edit Classroom
        </button>

        <button
          onClick={handleDeleteSubject}
          className="py-3 px-4 text-[#E34033] rounded-lg font-semibold font-satoshi"
          style={{ backgroundColor: "rgba(227, 64, 51, 0.2)" }}
        >
          Delete Classroom
        </button>
      </div>

      <DeleteItem isOpen={openDeleteModal} onClose={cancelModal}>
        <div>
          <h1 className="text-[20px] text-[#400167] font-bold">Delete Item?</h1>
          <p className="text-[14px] my-3">
            Are you sure you want to delete ‘Item’? Action can not be reversed.
          </p>
        </div>
        <div className="flex items-center gap-4 mt-3">
          <button
            className="bg-[#5002D0] text-white text-[16px] font-medium py-3 px-4 rounded-lg w-[102px]"
            onClick={confirmDelete}
          >
            Continue
          </button>
          <button
            className="text-[16px] font-medium py-3 px-4 rounded-lg w-[87px] text-[#E34033]"
            style={{ backgroundColor: "rgba(227, 64, 51, 0.2)" }}
            onClick={cancelModal}
          >
            Cancel
          </button>
        </div>
      </DeleteItem>

      <SuccessfulDelete
        isOpen={openSuccessfulDeleteModal}
        onClose={closeSuccessfulDeleteModal}
      />

      <EditClassroom
        isOpen={editModal}
        onClose={() => setEditModal(false)}
        classroom={classroom}
        setClassroom={setClassroom}
        description={description}
        setDescription={setDescription}
        members={members}
        setMembers={setMembers}
        handleUpdate={() => handleUpdate()}
      />

      <SuccessModal isOpen={successModal} onClose={closeSuccessModal} />
    </>
  );
};

export default ClassActivityBtn;
